import React, { FunctionComponent } from "react";
import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

export const ProcessIcon: FunctionComponent<SvgIconProps> = (props) => (
	<SvgIcon viewBox="0 0 24 24" {...props}>
		<path d="M13 10.5V8h2v2h6V4h-6v2h-2c-1.1 0-2 .9-2 2v3H8c-.4-.7-1-2-3-2-1.2 0-3 1-3 3s1.8 3 3 3c2 0 2.6-1.3 3-2h3v3c0 1.1.9 2 2 2h2v2h6v-6h-6v2h-2v-2.5" />
	</SvgIcon>
);

export default ProcessIcon;
